import {Dimensions, StyleSheet} from 'react-native';
import {colorPalette, defaultTheme, textStyles} from '../../../../../theme';

export default StyleSheet.create({
  button: {
    marginTop: 20,
    marginBottom: 20,
    marginHorizontal: 16,
  },
  container: {
    ...StyleSheet.absoluteFillObject,
    justifyContent: 'flex-end',
    alignItems: 'center',
    zIndex: 100,
    backgroundColor: 'rgba(0,0,0,0.3)',
    position: 'absolute',
  },
  content: {
    backgroundColor: defaultTheme.colors.whiteGrey0,
    width: Dimensions.get('window').width,
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12,
    zIndex: 1000,
    position: 'absolute',
    bottom: 0,
    alignItems: 'center',
  },
  closeBtn: {
    alignSelf: 'flex-end',
    marginTop: 10,
    marginBottom: -3,
    marginHorizontal: 16,
    marginRight: 'auto',
  },
  indicator: {
    backgroundColor: colorPalette.secondaryLighter2,
    height: 2,
    width: 36,
    marginTop: 10,
    marginBottom: 4,
    alignSelf: 'center',
  },
  vehicleRow: {
    alignSelf: 'stretch',
    flexDirection: 'row',
    marginTop: 20,
    marginHorizontal: 16,
  },
  specificBackground: {
    backgroundColor: colorPalette.grey0_5,
  },
  orContainer: {
    backgroundColor: colorPalette.whiteGrey0,
    alignSelf: 'stretch',
    paddingRight: 2,
    paddingLeft: 5,
    paddingVertical: 4,
    borderRadius: 16,
    position: 'absolute',
    left: Dimensions.get('window').width / 2 - 30,
    zIndex: 1,
  },
  orText: {
    fontFamily: textStyles.regular,
    fontSize: 11,
    color: colorPalette.grey9_5,
    marginRight: 4,
  },
  gap: {
    width: 4,
  },
  expire: {
    backgroundColor: colorPalette.grey0_5,
    marginTop: 8,
    marginBottom: 64,
    marginHorizontal: 16,
  },
  discountPercent: {
    marginRight: 8,
    fontSize: 11,
  },
  name: {
    fontFamily: textStyles.bold,
    fontSize: 16,
    color: colorPalette.grey8_5,
    marginTop: 12,
    marginHorizontal: 16,
  },
  description: {
    fontFamily: textStyles.regular,
    fontSize: 13,
    color: colorPalette.grey7,
    marginTop: 4,
    marginHorizontal: 16,
  },
  payFactor: {
    marginBottom: 14,
  },
  factorContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignSelf: 'stretch',
    alignItems: 'center',
    marginVertical: 6,
    marginHorizontal: 20,
  },
  factorText: {
    fontFamily: textStyles.medium,
    fontSize: 13,
  },
});
